module.exports = __webpack_public_path__ + "static/Gotham-Bold-16b27e61d660b618c0a56b9fd7b2b783.woff";